import $ from "jquery";

const $navbarToggler = $(".navbar-toggler");
const $mainMenu = $("#mainmenu");

export const init = () => {
  let $activeItems = $(".navbar-nav .active");
  function setDefaultActiveItems() {
    $(".navbar .open, .navbar .panel-open").removeClass("open panel-open");
    $activeItems.addClass("active");
    $(".navbar-nav .megamenu .submenu-wrapper").css("min-height", "");
  }

  $navbarToggler.click(function (e) {
    e.preventDefault();

    $("body").toggleClass("menu-open");
    $mainMenu.slideToggle();

    if (!$("body").hasClass("menu-open")) {
      setDefaultActiveItems();
    }
    //close  search when menu is open
    if ($("body").hasClass("search-open")) {
      $("body").removeClass("search-open");
    }

    e.stopPropagation();
  });

  let body = document.querySelector("body");
  document.addEventListener("click", (e) => {
    if (
      body.classList.contains("menu-open") &&
      e.target.closest(".navbar") == null &&
      e.target
    ) {
      $navbarToggler.click();
    }
  });

  $(".megamenu").on("mouseleave", function () {
    var windowWidth = window.innerWidth;
    if (windowWidth >= 1200) {
      setDefaultActiveItems();
    }
    $(this).find(".submenu-inner").css("min-height", "");
  });

  function columnOf($origin) {
    return $origin
      .closest(".submenu-inner")
      .children(".container")
      .children(".submenu");
  }

  // a main department stacks its children into the parent column, so their
  // flyouts compete for that column's single flyout slot
  function closeColumn($column) {
    $column
      .children(".has-submenu")
      .add(
        $column
          .children(".is-main-department")
          .children(".submenu")
          .children(".has-submenu")
      )
      .removeClass("open");
  }

  //Links in Sub Megamenu
  $(".megamenu .has-submenu > a").on("click", function (e) {
    let parent = $(this).closest(".has-submenu");
    if (!parent.hasClass("open")) e.preventDefault();

    let $inner = $(e.target).closest(".submenu-inner");
    $inner.css("min-height", "");

    var windowWidth = window.innerWidth;
    if (windowWidth < 1200) {
      //Mobile
      $(this).closest(".submenu-wrapper").addClass("open");
      parent.addClass("open");
    } else {
      //Desktop
      closeColumn(columnOf($(this)));
      $(this)
        .closest(".megamenu > .submenu-wrapper")
        .find("li.active")
        .removeClass("active");

      parent.addClass("open");

      let $submenus = $inner.find(".submenu-wrapper");
      let maxHeight = 0;
      $submenus.each(function () {
        let curHeight = $(this).height();
        if (curHeight > maxHeight) maxHeight = curHeight;
      });
      $inner.css("min-height", maxHeight);
    }
  });

  //Main departments expand their children as a panel inside the column
  $(".megamenu .is-main-department > a").on("click", function (e) {
    let parent = $(this).closest(".is-main-department");
    // flyout_nav_hide leaves a main department without a panel to expand
    if (!parent.children(".submenu").length) return;

    if (!parent.hasClass("panel-open")) e.preventDefault();
    parent.addClass("panel-open");
  });

  // Mobile menu
  //1 level links
  $(".navbar-nav > .has-submenu > .nav-link").on("click", function (e) {
    var windowWidth = window.innerWidth;
    if (windowWidth < 1200) {
      e.preventDefault();
      $(this).closest(".navbar-wrapper").addClass("open");
      $(this).closest(".has-submenu").addClass("open");
    }
  });

  //Back links to the 1st level
  $(
    ".navbar-nav > .has-submenu > .submenu-wrapper > .submenu-inner > .container > .parent-link"
  ).on("click", function (e) {
    e.preventDefault();
    let $this = $(this);
    $this.closest(".navbar-wrapper").removeClass("open");
    setTimeout(function () {
      $this.closest(".has-submenu").removeClass("open");
    }, 500);
  });

  //Back links to other levels
  $(".navbar-nav .submenu-wrapper .submenu-wrapper .parent-link").on(
    "click",
    function (e) {
      e.preventDefault();
      let $this = $(this);
      $this
        .closest(".has-submenu")
        .closest(".submenu-wrapper")
        .removeClass("open");
      setTimeout(function () {
        $this.closest(".has-submenu").removeClass("open");
      }, 500);
    }
  );

  $(window).on("load resize", function () {
    var windowWidth = window.innerWidth;
    if (windowWidth >= 1200) {
      $("body").removeClass("menu-open");
      $mainMenu.css("display", "");
      $mainMenu.find(".submenu").css("display", "");
      $mainMenu.find(".submenu-wrapper").css("display", "");
      setDefaultActiveItems();
    }
    $mainMenu.find(".submenu-inner").css("min-height", "");
  });

  //Close menu and search when modal is open
  let $modalBtns = $('[data-bs-toggle="modal"]');
  $modalBtns.each(function () {
    $(this).on("click", function () {
      if ($("body").hasClass("search-open")) {
        $("body").removeClass("search-open");
        $("#search").slideUp();
      }
      if ($("body").hasClass("menu-open")) {
        $("body").removeClass("menu-open");
        $("#mainmenu").slideUp();
      }
    });
  });
};
